'use strict';

exports.__esModule = true;
exports["default"] = {
    '-1': '請先登錄',
    'errNumber': '請輸入正確的手機號',
    'IS_RESERVED': '每個帳號只能預約一次，您已經預約過了喔',
    'no_check_code': '請輸入收到的驗證碼',
    'bookingS': '您已經預約成功了喔~趕緊去召回妳的男主吧!',
    'collectedAll': '您已經集齊了所有角色卡，請耐心等待伺服器開啟，一起前往半世界吧~',
    'shareC': '分享成功',
    'shareF': '分享失败',
    '-18001': '验证码发送失败，超过验证次数',
    '-18002': '验证码错误或超时',
    '-18003': '参数错误',
    '-18010': '服务商返回错误',
    '-18011': '参数错误，手机号码格式不正确或短信类型不存在',
    '-18012': '限制时间内重复发送',
    '-18013': '超过每日发送限制',
    '-18014': '用户已退订',
    '-18020': '系统错误'
};


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/tips.js
// module id = 35
// module chunks = 7 8